import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';

const Tutorial = ({
  tooltipRef,
  tutorialStep,
  setTutorialStep,
  setShowTutorial,
}) => {
  const maxTutorialSteps = 3;
  const { t } = useTranslation();

  const tutorialData = [
    {
      step: 1,
      title: t('tool_ui.tutorial.step_1_title'),
      description: t('tool_ui.tutorial.step_1_text'),
    },
    {
      step: 2,
      title: t('tool_ui.tutorial.step_2_title'),
      description: t('tool_ui.tutorial.step_2_text'),
    },
    {
      step: 3,
      title: t('tool_ui.tutorial.step_3_title'),
      description: t('tool_ui.tutorial.step_3_text'),
    },
  ];

  const currentTutorialData = tutorialData.find(
    (data) => data.step === tutorialStep
  );

  return (
    <div className={styles.tutorial}>
      <div className={styles.tutorialBg}></div>
      <div
        className={`${styles.tooltip} ${styles[`step${tutorialStep}`]}`}
        ref={tooltipRef}
      >
        <div className={styles.tooltip__buttonContainer}>
          <button
            className={styles['close--desktop']}
            onClick={() => setShowTutorial(false)}
          >
            <img
              src={`${process.env.PUBLIC_URL}/images_iax/icons/cross-white-desktop.svg`}
              alt='cross'
            />
          </button>
          <button
            className={styles['close--mobile']}
            onClick={() => setShowTutorial(false)}
          >
            <img
              src={`${process.env.PUBLIC_URL}/images_iax/icons/cross-white-mobile.svg`}
              alt='cross'
            />
          </button>
        </div>
        <h3>{currentTutorialData.title}</h3>
        <p>{currentTutorialData.description}</p>
        <div className={styles.tooltip__ctas}>
          {tutorialStep > 1 && (
            <>
              <button
                className={`${styles.buttonNavMobile} ${styles.buttonPrevious}`}
                onClick={() => setTutorialStep(tutorialStep - 1)}
              >
                {t('tool_ui.button.previous')}
              </button>
              <button
                className={`${styles.buttonNavDesktop} ${styles.buttonPrevious}`}
                onClick={() => setTutorialStep(tutorialStep - 1)}
              >
                {t('tool_ui.button.previous')}
              </button>
            </>
          )}
          {tutorialStep < maxTutorialSteps && (
            <>
              <button
                className={styles.buttonNavMobile}
                onClick={() => setTutorialStep(tutorialStep + 2)} //skip a step - no step 2 on mobile
              >
                {t('tool_ui.button.next')}
              </button>
              <button
                className={styles.buttonNavDesktop}
                onClick={() => setTutorialStep(tutorialStep + 1)}
              >
                {t('tool_ui.button.next')}
              </button>
            </>
          )}
          {tutorialStep === maxTutorialSteps && (
            <button onClick={() => setShowTutorial(false)}>
              {t('tool_ui.button.get_started')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Tutorial;
